import { useMemo, useState } from 'react'
import { ButtonGroup } from 'stories/components'

import { PricingRule } from './PricingRule'
import { Rules } from './Rules'

const menus: Record<string, string> = {
  rules: 'Rules',
  pricingRule: 'Pricing Rule',
}

export const RulesSection = () => {
  const [selectedMenu, setSelectedMenu] = useState('rules')

  const renderFragment = useMemo(() => {
    switch (selectedMenu) {
      case 'rules':
        return <Rules />
      case 'pricingRule':
        return <PricingRule />
      default:
        return null
    }
  }, [selectedMenu])

  return (
    <div>
      <div className="my-4">
        <ButtonGroup title={menus} value={selectedMenu} onChange={setSelectedMenu} />
      </div>
      {renderFragment}
    </div>
  )
}
